


















import { defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CtaButton from '../CtaButton.vue';

export default defineComponent({
	components: { CtaButton, FontAwesomeIcon },
});
